import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  justify-content: space-between;
  align-items: flex-start;
`

export const DetailText = styled.span`
  font-size: 16px;
  line-height: 20px;
  width: 100%;
  max-width: 280px;
  font-weight: 600;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 18px;
  }
`

export const DetailImgContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  align-items: baseline;
`

export const TextContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  padding-left: 6px;
  padding-right: 2px;
  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    margin: 0;
  }
`

export const DetailSubText = styled.p`
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
`
export const DetailSubTextBold = styled.p`
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  margin-left: 4px;
`

export const ViewCartButton = styled(Button)`
  font-size: 14px;
  line-height: 16px;
  padding: 0;
`

export const IconContainer = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2px;
`
